









































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubRepository} from '@/model/resource/GithubRepository'

@Component({})
export default class CDRepositoryDescription extends Vue {
  @Prop({type: GithubRepository, required: true})
  repository!: GithubRepository
}
